"use client";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import EventRow from "./EventRow";

type EventDescription = {
  title: string;
  subtitle: string;
};

const EVENT_DESCRIPTION: { [id: string]: EventDescription } = {
  MUSEUMS: {
    title: "Musées guidés",
    subtitle: "Découvrez les musées de Paris et ses environs",
  },
  FOOD_TASTING: {
    title: "Dégustation de vins/champagnes",
    subtitle: "Découvrez les meilleurs restaurants de Paris et ses environs",
  },
  ATTRACTIONS: {
    title: "Attractions",
    subtitle: "Découvrez les attractions de Paris et ses environs",
  },
  TICKETS: {
    title: "Billets",
    subtitle: "Découvrez les meilleurs tickets de Paris et ses environs",
  },
  TOURS: {
    title: "Balades guidées",
    subtitle: "Découvrez les meilleurs tours de Paris et ses environs",
  },
  MONUMENTS: {
    title: "Monuments",
    subtitle: "Découvrez les monuments de Paris et ses environs",
  },
  CRUISE: {
    title: "Croisières",
    subtitle: "Découvrez les croisières de Paris et ses environs",
  },
  SHOWS: {
    title: "Spectacles",
    subtitle: "Découvrez les spectacles de Paris et ses environs",
  },
  "SEGWAY/E-BIKE": {
    title: "Segway / E-Bike",
    subtitle: "Découvrez les spectacles de Paris et ses environs",
  },
  FOOD_TOURING: {
    title: "Balades et dégustations",
    subtitle: "Découvrez les meilleurs balades gustatives",
  },
  COOKING_CLASS:{
    title: "Cours de cuisine",
    subtitle: "Découvrez les meilleurs cours de cuisine",
  },
  TEST: {
    title: "Tests",
    subtitle: "",
  },
  WIP: {
    title: "En cours",
    subtitle: "",
  },
};

declare interface EventTableProps {
  user:User|null;
  events: Eventi[];
  isDisplayCommissions:boolean;
}

const EventTable = ({
  user,
  events,
  isDisplayCommissions=true
}: EventTableProps) => {

  return (
  
    <div className="flex flex-col items-center">
      <Table>
        <TableHeader className="bg-[#f9fafb]">
          <TableRow>
            <TableHead className="px-2">Activité</TableHead>
            <TableHead className="px-2">Prix</TableHead>
            {isDisplayCommissions && <TableHead className="px-2">Commission moyenne par ticket</TableHead>}
            <TableHead className="px-2"></TableHead>
            
          </TableRow>
        </TableHeader>
        <TableBody>
        

    <TableRow
      key={`BEST_SELLER`}
      className={`!over:bg-none !border-b-DEFAULT`}
    >

      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-20 text-left font-bold text-[#344054]">
          Meilleures expériences
          </h1>
          
        </div>
      </TableCell>

    </TableRow>
          {events.filter(
          (event) => event.eventTop
        ).map((event: Eventi, i) => (
            <EventRow
              key={`bestsller-${i}`}
              user={user}
              event={event}
              displayAll={isDisplayCommissions}
            />
          ))}

        {[
        "MUSEUMS",
        "MONUMENTS",
        "TOURS",
        "FOOD_TOURING",
        "FOOD_TASTING",
        "COOKING_CLASS",
        "ATTRACTIONS",
        "TICKETS",
        "CRUISE",
        "SEGWAY/E-BIKE",
        "SHOWS",
       //"TEST",
      ].map((category, index:number) => {
        const categoryEvents = events.filter(
          (event) => event.event_category === category
        );
        return (
          <>
          <TableRow
      key={`${category}-${index}`}
      className={`!over:bg-none !border-b-DEFAULT`}
    >

      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-20 text-left font-bold text-[#344054]">
            {EVENT_DESCRIPTION[category]?.title}
          </h1>
          
        </div>
      </TableCell>

    </TableRow>
          {categoryEvents.map((event: Eventi, i) => (
            <EventRow
              user={user}
              key={`${category}-${index}-${i}`}
              event={event}
              displayAll={isDisplayCommissions}
            />
          ))}
          </>
        );
      })}
        </TableBody>
      </Table>

    </div>
  );
};

export default EventTable;
